import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { CartService } from '../../services/cart.service';
import { Product } from '../../interfaces/product';
import { QuickviewService } from '../../services/quickview.service';
import { RootService } from '../../services/root.service';
import { CurrencyService } from '../../services/currency.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { WishlistService } from '../../services/wishlist.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-product-card',
    templateUrl: './product-card.component.html',
    styleUrls: ['./product-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductCardComponent implements OnInit, OnDestroy, OnChanges {
    private destroy$: Subject<void> = new Subject();

    @Input() product: Product;
    @Input() layout: 'grid-sm'|'grid-nl'|'grid-lg'|'list'|'horizontal'|null = null;

    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;
    buyingNow = false;
    showingQuickview = false;
    

    constructor(
        private cd: ChangeDetectorRef,
        public root: RootService,
        public cart: CartService,
        public quickview: QuickviewService,
        public currency: CurrencyService,
        public wishlist: WishlistService,
        private router:Router,
        private toster:ToastrService

    ) { }
isuk:boolean = false;
    ngOnInit(): void {
        var abc =window.location.href;
        if(abc.includes('.co.uk')){
            console.log('Redirecting to UK site');
            this.isuk = true;
        }
        else
        {
            console.log('Redirecting to Pakistan site');
        }
        console.log('jd',this.product)
        this.currency.changes$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.cd.markForCheck();
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('product' in changes) {
            
        }
    }

    addToCart(): void {
        if (this.addingToCart) {
            return;
        }

        this.addingToCart = true;
        this.cart.add(this.product, 1).subscribe({
            complete: () => {
                this.addingToCart = false;
                this.cd.markForCheck();
            }
        });
    }

    buyNow(): void {
        if (this.buyingNow) {
            return;
        }

        this.buyingNow = true;
        this.cart.add(this.product, 1).subscribe({
            complete: () => {
                this.buyingNow = false;
                this.cd.markForCheck();
                this.router.navigate(['/shop/cart/checkout'])
            }
        });
    }

    addToWishlist(): void {
        if (this.addingToWishlist) {
            return;
        }

        this.addingToWishlist = true;
        this.wishlist.add(this.product).subscribe({
            complete: () => {
                this.addingToWishlist = false;
                this.cd.markForCheck();
                this.toster.success('Product added to wishlist')
            }
        });
        
    }

    addToCompare(): void {
        if (this.addingToCompare) {
            return;
        }
        this.addingToCompare = true;
    }

    showQuickview(): void {
        if (this.showingQuickview) {
            return;
        }
        this.showingQuickview = true;
        this.quickview.show(this.product.slug).subscribe({
            complete: () => {
                this.showingQuickview = false;
                this.cd.markForCheck();
            }
        });
    }
    getquote(value){
        debugger
        console.log('getquote',value)
        value = ' ( Part Number:  '+value+' Quantity:  1  )  '
        this.router.navigate(['/home/getquote/'+value])
    }
}